import { Params } from 'ahooks/lib/useAntdTable/types';

const getSortOrder = (order?: 'ascend' | 'descend') => (order === 'descend' ? 'desc' : 'asc');

export const getTableQueryParams = (
  { current, pageSize, sorter }: Params[0],
  defaultSortField = 'id',
) => {
  const sortOrder = getSortOrder(sorter?.order);

  return {
    page: String(current),
    size: String(pageSize),
    sort: sorter?.order ? `${sorter.field},${sortOrder}` : `${defaultSortField},desc`,
  };
};

export const findTableRow = <T extends Record<string, unknown>>(
  recordKey: number,
  editableTableData: T[],
) => {
  const index = editableTableData.findIndex((item) => recordKey === item.key);
  const rowData = editableTableData[index];

  return rowData;
};
